import { KK } from '@/define/define'
import { Ref, ref, watch } from 'vue'

export enum OperateType {
  none,
  light,
  action,
  mgx,
  base,
  advanced,
}

class Operate {
  currentKey: Ref<KK> = ref(-1)
  currentHTMLElement: Ref<HTMLElement | null> = ref(null)
  private actionType = ref(OperateType.none)
  fnCheck = ref(false)

  constructor() {
    watch(this.fnCheck, () => {
      this.clear()
    })
  }

  changeActionType(type: OperateType) {
    this.actionType.value = type
    this.clear()
  }

  changeCurrentKey(key: KK) {
    this.currentKey.value = key
  }

  getCurrentKey() {
    return this.currentKey.value
  }

  getActionType() {
    return this.actionType
  }

  private clear() {
    this.currentKey.value = -1
  }
}
let operate = new Operate()
export { operate }
